import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-user-feedback-detail-report',
  templateUrl: './user-feedback-detail-report.component.html',
  styleUrls: ['./user-feedback-detail-report.component.scss']
})
export class UserFeedbackDetailReportComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: any = {};
   dtTrigger: Subject<any> = new Subject();

  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ufdForm: any = {};
  dashboardForm: any = {};
  ngOnInit(): void {
    $("#dateTime").val(this.datePipe.transform(new Date(), "yyyy-MM-dd"));
    // this.ViewAllDevices();
    this.ViewToilets();
    // this.FeedbackDetailReport();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          text: '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Detail Report'
        },
        {
          extend: 'excel',
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Detail Report'
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Detail Report'
        }
      ]
    };
  }

  // deviceRowdata;
  // device_details=[];
  // deviceDataArr;
  // async ViewAllDevices(){
  //   try {
  //     const deviceInfo = {
  //       'action': "view_device",
  //       'id':0,
  //     };
  //     const data: any = await this.request.post('',deviceInfo);
  //     this.device_details=[];
  //     for (let objKey of Object.keys(data)) {
  //       let dataObj = data[objKey];
  //       this.deviceRowdata = dataObj.data;
  //     }
  //     for (let objKey of Object.keys(this.deviceRowdata)) {
  //       let arr = {
  //         id:this.deviceRowdata[objKey].device_id,
  //         device_id:this.deviceRowdata[objKey].device_id
  //       };
  //       // console.log(arr);
  //       this.device_details.push(arr);
  //     }
  //     this.deviceDataArr = this.device_details;
  //   } catch (error) {}
  // }

  // deviceData = [];
  // deviceDataArr = [];

  toiletData = [];
  deviceDataArr = [];
  isLoading=false;
  async ViewToilets() {
    try {
      this.isLoading=true;
      this.toiletData=[];
      const device = {
        'toilet_id': 0,
      };
      const data: any = await this.request.post('/master/view_toilet',device);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].device_id,
              deviceLabel:`${dataObj[objKey1].device_id}:${dataObj[objKey1].address}(Zone -${dataObj[objKey1].zone_id}, Ward -${dataObj[objKey1].ward_id})`
            };
            // console.log(arr);
            this.toiletData.push(arr);
          } 
        }				
      }
      this.deviceDataArr = this.toiletData;
      // console.log(this.deviceDataArr);
      this.isLoading=false;
    } catch (error) {}
  }


  rowData;
  deviceLog=[];
  async FeedbackDetailReport() {
    try {
      this.isLoading=true;
      this.deviceLog=[];
      const today = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      let fromDate = this.datePipe.transform(this.ufdForm.fromDate|| today, "yyyy-MM-dd") + " 00:00:00";
      let toDate = this.datePipe.transform(this.ufdForm.toDate|| today, "yyyy-MM-dd") + " 23:59:59";
      const requestData = {
        'from_date': fromDate,
        'to_date': toDate,
        'deviceId': this.ufdForm.device_id
      };
      // console.log(requestData);
      // this.dtTrigger = new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data_details',requestData);
      // console.log(data);
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.deviceLog.push(dataObj);
      }
      // console.log(this.deviceLog);
      this.rowData = this.deviceLog;
      $('#feedbackTable').DataTable().destroy();
      this.dtTrigger.next();
      this.isLoading=false;
    } catch (error) { }

  }

}
